
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explorer/[square_version]/[api]/[endpoint]",
      function () {
        return require("private-next-pages/explorer/[square_version]/[api]/[endpoint].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explorer/[square_version]/[api]/[endpoint]"])
      });
    }
  